import Session from './session'

export default class BusinessHolidayAPI {

  static get PREFIX () {
    return Session.HOST + '/api/businessHoliday/'
  }

  /**
  * 年一覧取得
  */
  static getYearList () {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'yearList')
      .then(res => {
        return res
      })
      .catch(error => {
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
  * 年次休暇一覧取得
  */
  static list (year) {
    const s = new Session()
    return s.ins.get(this.PREFIX + `list?year=${year}`)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }


  /**
  * 登録更新
  */
  static upsert (data) {
    const s = new Session()
    return s.ins.post(this.PREFIX + 'upsert', data)
      .then(res => {
        return res
      })
      .catch(error => {
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
  * 削除
  */
  static delete (id) {
    const s = new Session()
    return s.ins.delete(this.PREFIX + 'delete/' + id)
      .then(res => {
        return res
      })
      .catch(error => {
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
  * コピー
  */
  static copy (from, to) {
    const s = new Session()
    return s.ins.post(`${this.PREFIX}copy?from=${from}&to=${to}`)
      .then(res => {
        return res
      })
      .catch(error => {
        return Promise.reject(error || 'ERROR')
      })
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/api/business-holiday-api.js